import { gql } from "@apollo/client";

export const NotificationFragment = gql`
  fragment NotificationFragment on Notification {
    content
    link
    template
    createdAt
    service
  }
`;
